import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, MouseEventHandler, useState } from 'react';

import { FileIcon, FileIconState, getFileIconThemeByExt, FileIconType } from '@gem/ui-kit';
import { getFileExt } from '@gem/utils';

import { useFileDownloadStatePresenter } from 'APP/hooks/useFileDownloadState/useFileDownloadState';

import styles from './FileState.styles.m.css';

interface IFileStateProps {
  iconType?: FileIconType;
  groupId: string;
  messageId: string;
  payloadId: string;
  className?: string;
  fileName?: string;
  onClick?: MouseEventHandler<SVGSVGElement | SVGGElement>;
}

export const FileState: FC<IFileStateProps> = observer((props) => {
  const { className, fileName, onClick, groupId, messageId, payloadId, iconType } = props;
  const [hover, setHover] = useState(false);

  const presenter = useFileDownloadStatePresenter({
    payloadId,
    groupId,
    messageId,
  });

  let state;

  if (presenter.hasError) {
    state = hover && onClick ? FileIconState.Hover : FileIconState.Error;
  } else if (presenter.isWaitingDownloadProcess) {
    state = FileIconState.Infinity;
  } else if (presenter.isDownloadInProcess) {
    state = FileIconState.Loading;
  } else if (presenter.isDownloadComplete) {
    state = hover && onClick ? FileIconState.Hover : FileIconState.Completed;
  } else {
    state = hover && onClick ? FileIconState.Hover : FileIconState.Regular;
  }

  if (iconType === FileIconType.Chat) {
    return (
      <div className={className}>
        <FileIcon
          type={iconType}
          className={classNames({
            [styles.pointer]: !presenter.isDownloadInProcess && !presenter.isWaitingDownloadProcess,
          })}
          state={state}
          onClick={onClick}
          progress={presenter.downloadPercent}
          onCancel={(e): void => {
            e.stopPropagation();
            presenter.onAbort();
          }}
          onMouseEnter={(): void => setHover(true)}
          onMouseLeave={(): void => setHover(false)}
        />
      </div>
    );
  }

  const fileExt = getFileExt(presenter.payload?.fileName || fileName);

  return (
    <div className={className}>
      <FileIcon
        className={classNames({
          [styles.pointer]: !presenter.isDownloadInProcess && !presenter.isWaitingDownloadProcess,
        })}
        text={fileExt}
        theme={getFileIconThemeByExt(fileExt)}
        state={state}
        onClick={onClick}
        progress={presenter.downloadPercent}
        onCancel={(e): void => {
          e.stopPropagation();
          presenter.onAbort();
        }}
        onMouseEnter={(): void => setHover(true)}
        onMouseLeave={(): void => setHover(false)}
      />
    </div>
  );
});
